import { client } from '../libs/client';
import { news, blogType } from '../types/cms-types';

export interface FormattedBlogItem {
  id: string;
  title: string;
  category: string;
  href: string;
}

export const fetchBlog = async (limit: number = 100): Promise<news[]> => {
  try {
    const response = await client.get({
      endpoint: 'news',
      queries: {
        limit,
        orders: '-publishedAt',
        depth: 2,
        filters: 'post_category[equals]blog',
      },
    });
    return response.contents;
  } catch (error) {
    console.error('ブログデータの取得に失敗しました:', error);
    throw error;
  }
};

export const formatBlogItems = (items: news[]): FormattedBlogItem[] => {
  return items.map((item) => ({
    id: item.id,
    title: item.post_title,
    category: (item.post_category as blogType)?.category_types || 'ブログ',
    href: `/2025/blog/${item.id}`,
  }));
};

export const fetchAndFormatBlog = async (limit: number = 100): Promise<FormattedBlogItem[]> => {
  const blogItems = await fetchBlog(limit);
  return formatBlogItems(blogItems);
};

export const getBlogById = async (id: string): Promise<news | null> => {
  try {
    const response = await client.get({
      endpoint: 'news',
      contentId: id,
      queries: {
        depth: 2,
      },
    });
    return response;
  } catch (error) {
    console.error('ブログ詳細の取得に失敗しました:', error);
    return null;
  }
};
